import { useState } from 'react'

export interface RemoveUserResponse {
  message: string
}

export interface UseRemoveUserResult {
  removeUser: (userId: string) => Promise<boolean>
  loading: boolean
  error: string | null
}

export function useRemoveUser(): UseRemoveUserResult {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const removeUser = async (userId: string): Promise<boolean> => {
    try {
      setLoading(true)
      setError(null)

      // Get auth token
      const token = localStorage.getItem('token')
      if (!token) {
        throw new Error('No authentication token found')
      }

      const response = await fetch(`/api/company/users/${userId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }))
        throw new Error(errorData.error || `Failed to remove user (${response.status})`)
      }

      // Success response (we don't need the data, just confirmation)
      await response.json()
      return true
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to remove user'
      setError(errorMessage)
      console.error('Error removing user:', err)
      return false
    } finally {
      setLoading(false)
    }
  }

  return {
    removeUser,
    loading,
    error
  }
}
